import { type MCPServerInfo } from '../../types';

const CloudZeroServer: MCPServerInfo = {
  serverId: 'CLOUDZERO',
  name: 'CloudZero',
  slug: 'cloudzero',
  description:
    'Query cloud cost data, get optimization recommendations, and access telemetry metrics from CloudZero using the Model Context Protocol.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://czca-server.discovery.cloudzero.com/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default CloudZeroServer;
